import React, { useRef } from "react";
import { useContext, useEffect, useReducer, useState } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import { CircularProgress } from "@mui/material";
import { ProviderList } from "./ProviderList";
import { PMStateContext } from "./context/PMStateContext";
import { PMDispatchContext } from "./context/PMDispatchContext";
import { initialState, pmReducer } from "./state/pmReducer";
import DataContext from "../../../../../context/DataContext";
import PermissionWrapper from "../../../../global/PermissionWrapper";
import { useLoaderData, useNavigate } from "react-router-dom";
import PaginationDefault from "../../../../ui library/components/paginations/pagination-default";
import { useQueryParams } from "../../../../../hooks/useQueryParams";
import Search from "../../../../ui library/components/filters/search";


//TODO: Permissions via current user service

const ProviderManager = () => {
  const { providers, resultCount } = useLoaderData();
  const { filters, updateFilter, bulkUpdateFilters } = useQueryParams();
  const { userRoles } = useContext(DataContext);
  const [state, dispatch] = useReducer(pmReducer, initialState);
  const [filteredProviders, setFilteredProviders] = useState(providers);
  const [canViewProviders, setCanViewProviders] = useState(true);

  const navigate = useNavigate();

  const scrollRef = useRef(null);

  const scrollToTop = () => {
    scrollRef.current.scroll({
      top: 0,
    });
  };

  useEffect(() => {
    let active = true;
    if (active) {
      bulkUpdateFilters([
        ["limit", 100],
        ["ordering", "name"],
        ["offset", 0],
      ]);
    }
    return () => {
      active = false;
    };
  }, []);

  useEffect(() => {
    let active = true;
    if (active) {
      setFilteredProviders(providers);
      if (scrollRef.current) {
        scrollToTop();
      }
    }
    return () => {
      active = false;
    };
  }, [providers, filters]);

  useEffect(() => {
    setCanViewProviders(
      userRoles.permissions.includes("provider.change_provider")
    );
  }, [userRoles?.permissions]);

  const handleOnDetailClick = (id) => {
    navigate(`/provider/${id}`);
  };
  return (
    <div
      data-testid="provider-manager"
      className="bg-white w-full overflow-hidden"
    >
      <PermissionWrapper permission={canViewProviders}>
        <PMStateContext.Provider value={state}>
          <PMDispatchContext.Provider value={dispatch}>
            <CssBaseline />
            <div className="p-6" data-testid="provider-manager-main">
              <div className="my-2">
                <h1 className="text-[1.8rem] font-medium">Manage Providers</h1>
                <div className="w-full mb-4">
                  <Search
                    id={"search"}
                    placeholder="Search by Provider Name, Address, City, State."
                    filters={filters}
                    updateFilter={updateFilter}
                  />
                </div>
              </div>
              <div className="flex flex-col gap-y-4">
                <div className="w-full">
                  {!filteredProviders ? (
                    <div className="flex justify-center my-24">
                      <CircularProgress color="secondary" />
                    </div>
                  ) : (
                    <div data-testid="provider-list">
                      <ProviderList
                        referenceForScrolling={scrollRef}
                        data={filteredProviders}
                        handleClick={handleOnDetailClick}
                        filters={filters}
                        updateFilter={updateFilter}
                      />
                    </div>
                  )}
                </div>
                <div className="w-fit mx-auto mt-auto">
                  <PaginationDefault
                    filters={filters}
                    updateFilter={updateFilter}
                    totalCount={resultCount}
                  />
                </div>
              </div>
            </div>
          </PMDispatchContext.Provider>
        </PMStateContext.Provider>
      </PermissionWrapper>
      <PermissionWrapper permission={!canViewProviders}>
        <div data-testid="no-access-message">
          You do not have permission to access.
        </div>
      </PermissionWrapper>
    </div>
  );
};

export default ProviderManager;
